// Wywiady i media - prof. Piotr Wysocki
// Dane wyciągnięte z oryginalnej strony onkolife.pl

export const interviews = [
  {
    id: 1,
    thumbnail: "/images/interview1.jpg",
    title: "Wywiad prasowy",
    source: "Prasa medyczna",
    href: "/_files/ugd/130a1b_dfe35d109d8a48cd98e17d98a22cec72.pdf",
    type: "PDF",
  },
  {
    id: 2,
    thumbnail: "/images/interview2.png",
    title: "W Krakowie zastosowano nową metodę leczenia raka",
    source: "TVP Kraków",
    href: "https://krakow.tvp.pl/43142485/w-krakowie-zastosowano-nowa-metode-leczenia-raka",
    type: "Wideo",
  },
  {
    id: 3,
    thumbnail: "/images/interview3.png",
    title: "Wywiad o onkologii klinicznej",
    source: "Magazyn branżowy",
    href: "/_files/ugd/130a1b_213d9370d86a43148b6abb7ab845a171.pdf",
    type: "PDF",
  },
  {
    id: 4,
    thumbnail: "/images/interview4.jpg",
    title: "Onkologia – nowe strategie terapeutyczne",
    source: "Czasopismo specjalistyczne",
    href: "/_files/ugd/130a1b_10249e21936e421c9fa55073737084bb.pdf",
    type: "PDF",
  },
  {
    id: 5,
    thumbnail: "/images/interview5.jpg",
    title: "Rozmowa o leczeniu nowotworów",
    source: "Prasa medyczna",
    href: "/_files/ugd/130a1b_e3533ad4eec24d929dc8367f29cd614c.pdf",
    type: "PDF",
  },
  {
    id: 6,
    thumbnail: "/images/interview6.png",
    title: "Co możemy zaoferować pacjentom z zaawansowanymi nowotworami trzustki",
    source: "Rynek Zdrowia",
    href: "https://www.rynekzdrowia.pl/Uslugi-medyczne/Prof-Piotr-Wysocki-co-mozemy-zaoferowac-pacjentom-z-zaawansowanymi-nowotworami-trzustki,141438,8.html",
    type: "Artykuł",
  },
  {
    id: 7,
    thumbnail: "/images/interview7.jpg",
    title: "Wywiad redakcyjny",
    source: "Magazyn medyczny",
    href: "/_files/ugd/130a1b_c2159a2901284e88866f312e1dbf8345.pdf",
    type: "PDF",
  },
  {
    id: 8,
    thumbnail: "/images/interview8.jpg",
    title: "O postępie w leczeniu onkologicznym",
    source: "Prasa medyczna",
    href: "/_files/ugd/130a1b_e5743cc5193e436a95b475160ce1fb78.pdf",
    type: "PDF",
  },
  {
    id: 9,
    thumbnail: "/images/interview9.png",
    title: "Onkologia – perspektywy",
    source: "Magazyn branżowy",
    href: "/_files/ugd/130a1b_1e8993427b41410e93a4700ff617be6b.pdf",
    type: "PDF",
  },
  {
    id: 10,
    thumbnail: "/images/interview10.png",
    title: "Sukces w leczeniu raka to mieszanina szczęścia, wiedzy medycznej i nastawienia pacjenta",
    source: "Radio Gdańsk",
    href: "https://radiogdansk.pl/wiadomosci/item/26208-onkolog-sukces-w-leczeniu-raka-to-mieszanina-szczescia-wiedzy-medycznej-i-nastawienia-pacjenta/26208-onkolog-sukces-w-leczeniu-raka-to-mieszanina-szczescia-wiedzy-medycznej-i-nastawienia-pacjenta",
    type: "Audio",
  },
];
